@if (ticketId != null) {
  <div class="flex">
    <!-- <app-reader-pdf [pdfReader]="field"></app-reader-pdf> -->dsadasdsa
    <div class="mat-button-wrapper">
      <button
        [ngClass]="{ 'btn-cancelar-enabled': pdfRendered }"
        mat-button
        class="btn-cancelar"
        [disabled]="!pdfRendered"
        (click)="onClose()"
      >
        {{ obj.action }}
      </button>
    </div>
  </div>
}
